
import './IgongChartReadingBook.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import MainPageSub04_2 from './MainPageSub04_2';

const IgongChartReadingBook = ({data, setIsJinroValue, setStudyJisu}) => {
  const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
  const selectedTestCode = useSelector((state) => state.reduxIgong.selectedTestCode);

    const [list, setList] = useState([]);
    const [donggiVaue, setDonggiValue] = useState(null);
    const [mokpyoVaue, setMokpyoValue] = useState(null);
    const [readingVaue, setReadingValue] = useState(null);
    const [readingVaueP, setReadingValueP] = useState(null);
    const [doghaeValue, setDoghaeValue] = useState(null);
    const [doghaeValue2, setDoghaeValue2] = useState(null);
    const [doghaeValueP, setDoghaeValueP] = useState(null);
    const [vocaValue, setVocaValue] = useState(null);
    const [vocaValueP, setVocaValueP] = useState(null);
    const [expression, setExpression] = useState(null);
    const [expression2, setExpression2] = useState(null);
    const [expression3, setExpression3] = useState(null);
    const [expressionP, setExpressionP] = useState(null);
    const [readership, setReadership] = useState(null);
    const [readership2, setReadership2] = useState(null);
    const [readership3, setReadership3] = useState(null);
    const [readershipP, setReadershipP] = useState(null);
    const [eveluationIndex, setEveluationIndex] = useState(null);
    const [eveluationIndexP, setEveluationIndexP] = useState(null);
    const [eveluationIndexDescription, setEveluationIndexDescription] = useState(null);
    

    useEffect(() => {
        const pTestCode = selectedTestCode;
        const stCode = selectedUserInfo.stCode;
        fncSelect_list_donggi(pTestCode, stCode);
        fncSelect_list_mokpyo(pTestCode, stCode);
        fncSelect_list_reading(pTestCode, stCode);
        fncSelect_list_doghae(pTestCode, stCode);
    }, [data]);

    function fncSelect_list_donggi(pTestCode, stCode) {
            fnc.sendAxios('/igongAssess_chart/studyAbility/select/donggi', {pTestCode, stCode}, (res) => {
                if (res && Array.isArray(res)) {
                  setDonggiValue(res[0].score_grade);
                } else {
                alert('검색에 실패했습니다(donggi)');
                }
            });       
    }              

    function fncSelect_list_mokpyo(pTestCode, stCode) {
      fnc.sendAxios('/igongAssess_chart/studyAbility/select/mokpyo', {pTestCode, stCode}, (res) => {
          if (res && Array.isArray(res)) {
            setMokpyoValue(res[0].score_grade);
          } else {
          alert('검색에 실패했습니다(donggi)');
          }
      });       
    } 
    
    function fncSelect_list_reading(pTestCode, stCode) {//3. 독서력
      fnc.sendAxios('/igongAssess_chart/studyAbility/select/reading', {pTestCode, stCode}, (res) => {
          if (res && Array.isArray(res)) {
            const bookCnt = res[0].cnt;
            setReadingValue(bookCnt);
            const resScore = getBookScore(bookCnt);
            setReadingValueP(resScore);

            function getBookScore(bookCnt) {
              if (bookCnt >= 20) return 100;
              if (bookCnt >= 15) return 80;
              if (bookCnt >= 10) return 60;
              if (bookCnt >= 5) return 40;
              return 20;
            }

          } else {
          alert('검색에 실패했습니다(donggi)');
          }
      });       
    }              

    function fncSelect_list_doghae(pTestCode, stCode) {//3. 독해력
      fnc.sendAxios('/igongAssess_chart/studyAbility/select/doghae', {pTestCode, stCode}, (res) => {
          if (res && Array.isArray(res)) {
            //학생이 속하는 영역 최대 2개에 해당하는 (잡스, 현대) 것의 독서개수 가져오기.
            const top2 = [...data]
            .sort((a, b) => b.value - a.value) // value 내림차순 정렬
            .slice(0, 2); // 상위 2개만 추출

            const firstName = top2[0].name + '형';
            const secondName = top2[1].name + '형';
  
            console.log(firstName, '형');
            const firstCnt = res.find(item => item.typeName === firstName)?.bookCnt || 0;
            const secondCnt = res.find(item => item.typeName === secondName)?.bookCnt || 0;
            const area12Cnt = firstCnt + secondCnt;
            setDoghaeValue(area12Cnt);
          } else {
          alert('검색에 실패했습니다(donggi)');
          }
      });       
    }   


    
    useEffect(() => {//독해력
      const res = Math.round(doghaeValue / readingVaue * 100 * 10)/10 ;
      setDoghaeValue2(res)//퍼센트
      const res2 = getGradeByPercent(res);
      setDoghaeValueP(res2);//점수
    }, [readingVaue, doghaeValue]);

    function getGradeByPercent(percent) {
      if (percent >= 65) return 100;
      if (percent >= 50) return 80;
      if (percent >= 30) return 60;
      if (percent >= 10) return 40;
      return 20;
    }
        
    useEffect(() => {//어휘력
      const res1 = readingVaue - doghaeValue;
      const res2 = getGradeByPercent(res1)

      setVocaValue(res1)
      setVocaValueP(res2)

      function getGradeByPercent(percent) {
        if (percent >= 18) return 100;
        if (percent >= 12) return 80;
        if (percent >= 7) return 60;
        if (percent >= 3) return 40;
        return 20;
      }

    }, [readingVaue, doghaeValue]);


    useEffect(() => {//표현력
      const top3Score = readingVaueP + doghaeValueP + vocaValueP;
      setExpression(top3Score);
      const top3AreaValue = getTop3Value();
      setExpression2(top3AreaValue);
      let res3 = (top3Score + top3AreaValue) / 4;
      res3 = Math.round(res3 * 10) / 10 ;
      setExpression3(res3);
      const finalValue = getGradeByPercent_expression(res3)
      setExpressionP(finalValue);

      function getGradeByPercent_expression(percent) {
        if (percent >= 85) return 100;
        if (percent >= 75) return 80;
        if (percent >= 60) return 60;
        if (percent >= 40) return 40;
        return 20;
      }

    }, [readingVaueP, doghaeValueP, vocaValueP]);
    
 

    function getTop3Value() {
        //학생이 속하는 영역 최대 3개에 해당하는 (잡스, 현대) 것의 독서개수 가져오기.
        const top3 = [...data]
        .sort((a, b) => b.value - a.value) // value 내림차순 정렬
        .slice(0, 3); // 상위 3개만 추출

        const nth1 = top3[0].name;
        const nth2 = top3[1].name;
        const nth3 = top3[2].name;

        const valueArr = [
          { typeName: '잡스', value: 27.5 },
          { typeName: '현대', value: 22.5 },
          { typeName: '노벨', value: 32.5 },
          { typeName: '유비', value: 17.5 }
        ]
        
        const resV1 = valueArr.find(item => item.typeName === nth1)?.value || 0;
        const resV2 = valueArr.find(item => item.typeName === nth2)?.value || 0;
        const resV3 = valueArr.find(item => item.typeName === nth3)?.value || 0;
        // console.log(resV1,resV2, resV3,  'resV3resV3resV3resV3형');
        return resV1 + resV2 + resV3;
    }

    
    useEffect(() => {//주도력
      const res1 = readingVaueP + doghaeValueP + vocaValueP + mokpyoVaue;
      setReadership(res1);
      const res2 = Math.round(res1 / 4 * 10 /10);
      setReadership2(res2);
      const resFinal = getGradeByPercent(res2)
      setReadershipP(resFinal);

      function getGradeByPercent(percent) {
        if (percent >= 80) return 100;
        if (percent >= 70) return 80;
        if (percent >= 60) return 60;
        if (percent >= 50) return 40;
        return 20;
      }

    }, [readingVaueP, doghaeValueP, vocaValueP]);

    useEffect(() => {//공부력 평가지수
      const res1 = donggiVaue + mokpyoVaue + readingVaueP + doghaeValueP + vocaValueP + expressionP + readershipP;
      setEveluationIndex(res1);
      let res2 = Math.round(res1 / 700 * 100 * 100)/100;
      setEveluationIndexP(res2);
      const res3 = getScoreDescription(res2);
      setEveluationIndexDescription(res3);

      function getScoreDescription(score) {
        if (score >= 80) return "최상위권 4% 이내 가능";
        if (score >= 75) return "상위권 10% 이내 가능";
        if (score >= 70) return "상위권 15% 이내 가능";
        if (score >= 65) return "상위권 20% 이내 가능";
        if (score >= 60) return "상위권 25% 이내 가능";
        if (score >= 55) return "상위권 30% 이내 가능";
        if (score >= 40) return "지속력 및 지구력의 문제로 보임ㅣ목표의식 필요ㅣ맟춤코칭 및 상담 필요";
        if (score >= 30) return "전반적인 학업역량 밸런스 부조화 상태｜상담 필요";
        if (score >= 20) return "목표 및 주도력 부재ㅣ문해력 부족ㅣ맟춤코칭 및 상담 필요";
        return "측정 불가ㅣ무기력 상태로 판단ㅣ맟춤코칭 및 상담 필요";
      }

      // setIsJinroValue(mokpyoVaue);
      // setStudyJisu(res2);
  // alert(mokpyoVaue)
  // alert(res2 + '평가지수2')
    }, [readingVaueP, doghaeValueP, vocaValueP]);


    setTimeout(() => {
      setIsJinroValue(mokpyoVaue);
      setStudyJisu(eveluationIndexP);
    }, [3000]);

    const barData = [
      { label: "동기부여", score: donggiVaue },
      { label: "목표의식", score: mokpyoVaue },
      { label: "독서력", score: readingVaueP },
      { label: "독해력", score: doghaeValueP },
      { label: "어휘력", score: vocaValueP },
      { label: "표현력", score: expressionP },
      { label: "주도력", score: readershipP }
    ];
    
//=========================================
  return (
    <div className='IgongChartReadingBook'>
    <div className='title'>공부력 평가지수</div>
    {/* -------------------------------------지우지 말것 검증용 */}
   
  {false && 
    <section className=''>
      <div>동기: {donggiVaue}</div>
      <div>목표: {mokpyoVaue}</div>
      <div>독서력: {readingVaue}, {readingVaueP}</div>
      <div>독해력: {doghaeValue}, {doghaeValue2}, {doghaeValueP}</div>
      <div>어휘력: {vocaValue}, {vocaValueP}</div>
      <div>표현력: {expression}, {expression2}, {expression3}, {expressionP}</div>
      <div>주도력: {readership}, {readership2}, {readershipP}</div>
      {/* p는 퍼센트 */}
      <div>평가지수: {eveluationIndex}, {eveluationIndexP}</div> 
      <div>평가설명: {eveluationIndexDescription}</div>
    </section>
    }
    {/* 공부력을 좌우하는 것은 바로 이것이다! 와 그래프 같이 있음 */}
    <MainPageSub04_2 
        barData={barData} 
        eveluationIndexP={eveluationIndexP}
        eveluationIndexDescription={eveluationIndexDescription}
    />

{/* 평가점수 : eveluationIndex */}
    
    </div>

  

  );
};

export default IgongChartReadingBook;